export var DialogTabs;
(function (DialogTabs) {
    DialogTabs["GENERAL"] = "General";
    DialogTabs["NUTRITION"] = "Nutrition";
    DialogTabs["CUSTOMIZE"] = "Customize";
})(DialogTabs || (DialogTabs = {}));
